import React from 'react';
import { Box, Radio, Typography } from '@material-ui/core';

export const YesNoFieldPreview = React.memo(() => (
  <Box display='flex' alignItems='center'>
    <Radio disabled size='small' />
    <Typography variant='body2' color='textSecondary' style={{ marginRight: 16 }}>
      Yes
    </Typography>
    <Radio disabled size='small' />
    <Typography variant='body2' color='textSecondary'>
      No
    </Typography>
  </Box>
));
